module.exports = __webpack_public_path__ + "assets/img/07b.7c7e8fb4.jpg";